import React from 'react'
import './side.scss'
import { HiOutlineClipboardCheck, HiOutlineLocationMarker } from 'react-icons/hi'
import {Link } from 'react-router-dom';
import { getTripsByCategory } from '../../../../services/tripServices';
import { IMAGE_BASE_URL } from '../../../../config';

const Side = ({category}) =>{

    const [data, setData] = React.useState([]);
    React.useEffect(() => {
        getTripsByCategory(category).then((response) => {
            setData(response.data);
        }).catch((error) => {
            console.log("Error fetching trips by category:", error);
        });
    }, [category]);

    return(
        <div className="Main">
        <section className='Main container section'>


            <div className="SecContent grid">

                { data &&
                    data.map((item) => {
                        return(
                            <div key={item.id} className='SingleDestination'>

                                <div className="ImageDiv">
                                    <img src={`${IMAGE_BASE_URL}/${item.imgSrc}`} alt={item.title} />
                                </div>
                                
                                <div className="CardInfo">
                                    <h4 className='DestTitle'>{item.title}</h4>
                                    <span className="Continent flex">
                                        <HiOutlineLocationMarker className='icon'/>
                                        <h4 className="Name">{item.location}</h4>
                                    </span>
                                    <div className="desc">
                                        <p>{item.description}</p>
                                    </div>

                                    <Link to={`/${item.id}`} className='btn flex'>
                                    DETAILS <HiOutlineClipboardCheck className='icon' />
                                    </Link>
                                </div>

                            </div>
                        )
                    })
                }

            </div>
        </section>
        </div>

    )
}

export default Side;